<template>
  <MainLayout page-name="registration-symbol-master">
    <PageHeader :title="title">
      <el-row class="header-button">
        <el-col>
          <el-button type="primary" class="import" @click="clickImport">新規取込</el-button>
        </el-col>
        <el-col>
          <el-button type="primary" class="register" @click="clickRegister">新規追加</el-button>
        </el-col>
        <el-col>
          <el-button type="primary" class="detail-search" @click="clickDetailSearch">詳細検索</el-button>
        </el-col>
      </el-row>
      <SimpleSearch
        :model="simpleSearchFormModel"
        @search="clickSearch"
      >
        <RegistrationSymbol v-model="simpleSearchFormModel.registration_symbol" :searchCond="true" :autocomplete-list="registrationSymbolSet" />
        <OwnerCode v-model="simpleSearchFormModel.owner_code" :searchCond="true" :autocomplete-list="ownerCodeSet" />
        <ModelCode v-model="simpleSearchFormModel.model_code" :searchCond="true" :autocomplete-list="modelCodeSet" />
        <AircraftType v-model="simpleSearchFormModel.aircraft_type" :searchCond="true" :initialize="true" placeholder="機体区分" label="" />
        <div class="dummy">
          <AircraftAttribute :initialize="true" />
        </div>
      </SimpleSearch>
    </PageHeader>
    <Table
      :table-data="tableData"
      :csv-export="true"
      csv-file-name="登録機データ.CSV"
      :dataFormatter="csvDataFormatter"
      :default-sort="{ prop: 'registration_symbol', order: 'ascending' }"
      csv-encoding="SJIS"
      :table-header-name="tableHeaderName"
      @row-click="clickRow"
      @multiple-delete="deleteRows"
    >
      <template #columns>
        <!-- <RegistrationSymbolColumn />
        <OwnerCodeColumn :sortable="true" />
        <DateColumn label="適用開始日" prop="start_date" :sortable="true" />
        <DateColumn label="適用終了日" prop="end_date" :sortable="true" />
        <ModelCodeColumn :sortable="true" />
        <AircraftTypeColumn :sortable="true" />
        <WeightColumn label="重量1" prop="weight_1" :sortable="true" />
        <NoiseLevelColumn label="騒音値1" prop="noise_level_1" :sortable="true" />
        <BlankColumn />
        <MenuColumn @copy="copyRow" :cbdelete="deleteRow" /> -->
        <RegistrationSymbolColumn />
        <OwnerCodeColumn />
        <DateTimeColumn label="適用開始日時" prop="start_date" />
        <DateTimeColumn label="適用終了日時" prop="end_date" />
        <!-- <DateColumn label="適用開始日" prop="start_date" /> -->
        <!-- <DateColumn label="適用終了日" prop="end_date" /> -->
        <ModelCodeColumn />
        <AircraftTypeColumn />
        <WeightColumn label="重量1" prop="weight_1" />
        <NoiseLevelColumn label="騒音値1" prop="noise_level_1" />
        <BlankColumn />
        <MenuColumn @copy="copyRow" :cbdelete="deleteRow" />
      </template>
    </Table>
    <RegistrationSymbolMasterImportDialog
      :visible.sync="importDialogVisible"
      @refresh="refreshSearch"
    />
    <RegistrationSymbolMasterRegisterDialog
      :visible.sync="registerDialogVisible"
      :autocomplete-registration-symbol-set="registrationSymbolSet"
      :autocomplete-owner-code-set="ownerCodeSet"
      :autocomplete-model-code-set="modelCodeSet"
      :current-row="currentRow"
      @refresh="refreshSearch"
    />
    <RegistrationSymbolMasterDetailSearchDialog
      :visible.sync="detailDalogVisible"
      :autocomplete-registration-symbol-set="registrationSymbolSet"
      :autocomplete-owner-code-set="ownerCodeSet"
      :autocomplete-model-code-set="modelCodeSet"
      @search="detailSearch"
    />
    <RegistrationSymbolMasterEditDialog
      :visible.sync="editDialogVisible"
      :autocomplete-owner-code-set="ownerCodeSet"
      :autocomplete-model-code-set="modelCodeSet"
      :current-row="currentRow"
      @refresh="refreshSearch"
    />
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/templates/MainLayout.vue'
import PageHeader from '@/components/organisms/PageHeader.vue'
import RegistrationSymbol from '@/components/molecules/form/autocomplete/RegistrationSymbol.vue'
import OwnerCode from '@/components/molecules/form/autocomplete/OwnerCode.vue'
import ModelCode from '@/components/molecules/form/autocomplete/ModelCode.vue'
import AircraftType from '@/components/molecules/form/select/AircraftType.vue'
import AircraftAttribute from '@/components/molecules/form/select/AircraftAttribute.vue'
import SimpleSearch from '@/components/organisms/SimpleSearch.vue'
// import Table from '@/components/molecules/table/Table.vue'
import Table from '@/components/molecules/table/TablePaging.vue'
import RegistrationSymbolColumn from '@/components/molecules/table/RegistrationSymbolColumn.vue'
import OwnerCodeColumn from '@/components/molecules/table/OwnerCodeColumn.vue'
import DateTimeColumn from '@/components/molecules/table/DateTimeColumn.vue'
// import DateColumn from '@/components/molecules/table/DateColumn.vue'
import ModelCodeColumn from '@/components/molecules/table/ModelCodeColumn.vue'
import AircraftTypeColumn from '@/components/molecules/table/AircraftTypeColumn.vue'
import WeightColumn from '@/components/molecules/table/WeightColumn.vue'
import NoiseLevelColumn from '@/components/molecules/table/NoiseLevelColumn.vue'
import BlankColumn from '@/components/molecules/table/BlankColumn.vue'
import MenuColumn from '@/components/molecules/table/MenuColumn.vue'
import RegistrationSymbolMasterImportDialog
  from '@/components/pages/master/registrationSymbolMaster/RegistrationSymbolMasterImportDialog.vue'
import RegistrationSymbolMasterRegisterDialog
  from '@/components/pages/master/registrationSymbolMaster/RegistrationSymbolMasterRegisterDialog.vue'
import RegistrationSymbolMasterDetailSearchDialog
  from '@/components/pages/master/registrationSymbolMaster/RegistrationSymbolMasterDetailSearchDialog.vue'
import RegistrationSymbolMasterEditDialog
  from '@/components/pages/master/registrationSymbolMaster/RegistrationSymbolMasterEditDialog.vue'
import RegistrationSymbolAutocompleteLoader from '@/mixins/RegistrationSymbolAutocompleteLoader.vue'

export default {
  components: {
    MainLayout,
    PageHeader,
    RegistrationSymbol,
    OwnerCode,
    ModelCode,
    AircraftType,
    AircraftAttribute,
    SimpleSearch,
    Table,
    RegistrationSymbolColumn,
    OwnerCodeColumn,
    DateTimeColumn,
    // DateColumn,
    ModelCodeColumn,
    AircraftTypeColumn,
    WeightColumn,
    NoiseLevelColumn,
    BlankColumn,
    MenuColumn,
    RegistrationSymbolMasterImportDialog,
    RegistrationSymbolMasterRegisterDialog,
    RegistrationSymbolMasterDetailSearchDialog,
    RegistrationSymbolMasterEditDialog
  },
  mixins: [
    RegistrationSymbolAutocompleteLoader
  ],
  data () {
    return {
      title: '登録機マスタ',
      tableData: [],
      tableHeaderName: ['登録記号', '適用開始日', '適用終了日', '機種コード', '機体区分', '所有者', '重量１', '騒音値１', '重量２', '騒音値２', '重量３', '騒音値３', '備考', '機体属性'],
      simpleSearchFormModel: {
        registration_symbol: '',
        owner_code: '',
        model_code: '',
        aircraft_type: ''
      },
      currentRow: {},
      importDialogVisible: false,
      registerDialogVisible: false,
      detailDalogVisible: false,
      editDialogVisible: false
    }
  },
  computed: {
  },
  mounted () {
    sessionStorage.removeItem('registrationSymbolSearchCond')
    this.loadRegistrationSymbol()
  },
  methods: {
    clickImport () {
      this.importDialogVisible = true
    },
    clickRegister () {
      this.currentRow = {}
      this.registerDialogVisible = true
    },
    clickDetailSearch () {
      this.detailDalogVisible = true
    },
    clickSearch () {
      sessionStorage.setItem('registrationSymbolSearchCond', JSON.stringify(this.simpleSearchFormModel))
      this.search()
    },
    detailSearch () {
      const searchCond = JSON.parse(sessionStorage.getItem('registrationSymbolSearchCond'))
      Object.keys(this.simpleSearchFormModel).forEach((x) => { this.$set(this.simpleSearchFormModel, x, searchCond[x]) })
      this.search()
    },
    search () {
      this.$loadingMask.on()
      const searchCond = JSON.parse(sessionStorage.getItem('registrationSymbolSearchCond'))
      this.$axios
        .get('/search-registration-symbol', { params: searchCond })
        .then((res) => {
          this.tableData = res.data.list
          for (var i = 0; i <= this.tableData.length - 1; i += 1) {
            // this.tableData[i].selected = false
            this.$set(this.tableData[i], 'selected', false)
          }
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    refreshSearch () {
      this.search()
      this.margeRegistrationSymbolSet(this.tableData.map((x) => x.registration_symbol))
      this.margeOwnerCodeSet(this.tableData.map((x) => x.owner_code))
      this.margeModelCodeSet(this.tableData.map((x) => x.model_code))
      this.refreshRegistrationSymbolAutocompleteList()
    },
    csvDataFormatter (row) {
      const result = { ...row }
      delete result.selected
      delete result.updated_on
      Object.keys(result)
        .forEach((x) => {
          if (result[x] === null) {
            result[x] = ''
          }
        })

      return result
    },
    // clickRow (row, column, event) {
    //   this.currentRow = row
    //   this.editDialogVisible = true
    // },
    clickRow (row, table) {
      this.currentRow = row
      this.editDialogVisible = true
      this.tableData = table
    },
    copyRow (row) {
      this.currentRow = row
      this.registerDialogVisible = true
    },
    deleteRow (row) {
      this.deleteRows([row])
    },
    async deleteRows (rows) {
      if (!(await this.$fcMessage.messageBox(this.title, 'CMN0003W'))) {
        return
      }

      this.$loadingMask.on()
      await this.$axios
        .delete('/registration-symbol', { data: rows })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.search()
        })
        .catch((e) => {
          this.$loadingMask.off()
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message, true)
                break
              default:
            }
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.header-button {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  margin-bottom: 2rem;
  ::v-deep .el-col {
    width: auto;
    margin-left: 2rem;
    .el-button {
      font-size: inherit;
      width: 13em;
    }
  }
}
.dummy {
  display: none;
}
</style>
